import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Wrench, AlertTriangle } from "lucide-react";

/* Priority 4/5 — takeoff toolchain health pill for the cockpit. GREEN when the native parsers are installed
   (scanned-sheet OCR + native .dwg CAD); AMBER when one is missing, so an operator instantly knows a scanned
   sheet or DWG could not be auto-read and needs a MANUAL takeoff (never silently skipped / fabricated). */
export function TakeoffToolsBadge() {
  const [tools, setTools] = useState(null);
  useEffect(() => {
    let alive = true;
    api.get("/system/takeoff-tools").then((r) => { if (alive) setTools(r.data); }).catch(() => {});
    return () => { alive = false; };
  }, []);
  if (!tools) return null;

  const ok = tools.all_ok;
  const missing = [];
  if (!tools.ocr?.available) missing.push("scanned-sheet OCR (tesseract)");
  if (!tools.cad_dwg?.available) missing.push("native .dwg CAD (dwg2dxf/ODA)");
  const title = ok
    ? "Takeoff toolchain healthy — scanned sheets are OCR-read and native .dwg drawings are parsed automatically."
    : `MANUAL TAKEOFF NEEDED for: ${missing.join(" + ")}. `
      + [tools.ocr?.note, tools.cad_dwg?.note].filter(Boolean).join(" ");

  return (
    <span
      data-testid="takeoff-tools-badge"
      data-ok={ok ? "true" : "false"}
      title={title}
      className={`flex items-center gap-1.5 text-[10px] font-medium px-2 py-1 rounded-md border ${
        ok
          ? "bg-emerald-500/15 text-emerald-300 border-emerald-500/30"
          : "bg-amber-500/15 text-amber-300 border-amber-500/40"
      }`}
    >
      {ok ? <Wrench className="h-3 w-3" /> : <AlertTriangle className="h-3 w-3" />}
      {ok ? "Takeoff tools ready" : "Manual takeoff needed"}
    </span>
  );
}
